import { useState, useMemo, useCallback, FC, Fragment } from 'react'
import { Button, ButtonToolbar } from 'react-bootstrap'

import { LDLItem, ToolboxItem, ToolName } from '../Types'
import Confirm from './Confirm'
import './Toolbox.scss'
import LDL from './LDL'
import { useModuleContext } from '../contexts/ModuleContext'

interface Props {
    tools: ToolboxItem[]
    ldlInfo: LDLItem
    selectTool: Function
    toggleLockout: Function
    acceptLDL: Function
    isPowerOn: boolean
    isTaggedOut: boolean
}

const Toolbox: FC<Props> = ({ tools, ldlInfo, selectTool, toggleLockout, acceptLDL, isPowerOn, isTaggedOut }: Props) => {
    const { user } = useModuleContext()
    const [showConfirmLockout, setShowConfirmLockout] = useState(false)
    const [showLDL, setShowLDL] = useState(false)
    const [lockoutTool, setLockoutTool] = useState({} as ToolboxItem)

    const hideConfirmLockout = () => setShowConfirmLockout(false)
    const hideLDL = () => setShowLDL(false)

    const handleLocker = (tool: ToolboxItem) => {
        if (!tool.unityObject || !tool.action) return
        selectTool(tool.unityObject, tool.action)
        toggleLockout()
        setShowConfirmLockout(false)
        setShowLDL(true)
    }

    const acceptLdl = () => {
        acceptLDL()
        setShowLDL(false)
    }

    const handleToolClick = useCallback((e: MouseEvent, tool: ToolboxItem) => {
        e.preventDefault()
        e.stopPropagation()

        switch (tool.name) {
            case ToolName.LockerOpen:
                setShowConfirmLockout(true)
                setLockoutTool(tool)
                break
            case ToolName.LockerLocked:
                selectTool(tool.unityObject, tool.action)
                toggleLockout()
                break
            default:
                if (tool.unityObject !== undefined && tool.action !== undefined) selectTool(tool.unityObject, tool.action)
                break
        }
    }, [selectTool, toggleLockout])

    const toolboxItems = useMemo(() => tools.map((tool: ToolboxItem, idx: number) => {
        if ((tool.name === ToolName.LockerOpen && isTaggedOut) || (tool.name === ToolName.LockerLocked && !isTaggedOut)) { return <Fragment key={'rf' + idx} /> }
        const disabled = (tool.name === ToolName.LockerOpen) ? isPowerOn : false
        return (
            <Button
                key={'t' + idx}
                className={`${tool.name}`}
                onClick={(e: any) => handleToolClick(e, tool)}
                disabled={disabled}
            />
        )
    }), [handleToolClick, isPowerOn, isTaggedOut, tools])

    return (
        <>
            <ButtonToolbar className="toolbox justify-content-end flex-nowrap">
                {toolboxItems}
            </ButtonToolbar>
            <Confirm
                key='confirmlockout'
                show={showConfirmLockout}
                title='Lockout-tagout'
                body='Do you want to apply your lock and DO NOT OPERATE tag?'
                onConfirm={() => {
                    handleLocker(lockoutTool)
                }}
                onHide={hideConfirmLockout}
                confirmText='OK'
                cancelText='Cancel'
            />
            <LDL
                ldlInfo={ldlInfo}
                show={showLDL}
                onHide={hideLDL}
                onAccept={acceptLdl}
                electricalCode={user.electricalCode}
            />
        </>
    )

}

export default Toolbox